import { render, staticRenderFns } from "./RequestFriendBoxV2.vue?vue&type=template&id=4beaa3ec&scoped=true"
import script from "./RequestFriendBoxV2.vue?vue&type=script&lang=js"
export * from "./RequestFriendBoxV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beaa3ec",
  null
  
)

export default component.exports